import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "text-lg text-textPrimary font-bold" }
const _hoisted_5 = {
  class: "text-left text-3xl font-bold text-textPrimary",
  "data-testid": "summary-card-count"
}

import { computed } from 'vue'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'
import { ExceptionStatusEnum } from '@/Network/Types/Requests/DoctorStationExceptionRequests'

interface StatusConfig {
  border: string
  textColor: string
  icon: string
  label: string
  key: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionalitySummaryCard',
  props: {
    status: {},
    count: {}
  },
  setup(__props: any) {

const props = __props;



const STATUS_MAP: Record<string, StatusConfig> = {
  [ExceptionStatusEnum.AWAITING_APPROVAL]: {
    border: 'border-alert',
    textColor: 'text-alert',
    icon: mdiLock,
    label: 'Em andamento',
    key: 'in-progress'
  },
  [ExceptionStatusEnum.APPROVED]: {
    border: 'border-negative',
    textColor: 'text-negative',
    icon: mdiLockOpenVariant,
    label: 'Aprovado',
    key: 'approved'
  },
  [ExceptionStatusEnum.REJECTED]: {
    border: 'border-primary',
    textColor: 'text-primary',
    icon: mdiLock,
    label: 'Reprovado',
    key: 'rejected'
  }
}

const DEFAULT_CONFIG: StatusConfig = {
  border: 'border-gray-300',
  textColor: 'text-gray-500',
  icon: mdiLock,
  label: 'Desconhecido',
  key: 'unknown'
}

const config = computed(() => STATUS_MAP[props.status] ?? DEFAULT_CONFIG)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([config.value.border, "rounded-lg border-2 bg-white p-4 flex flex-col gap-3 flex-1 min-w-[180px]"]),
    "data-testid": `summary-card-${config.value.key}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center gap-1 text-sm font-medium", config.value.textColor])
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("path", {
          d: config.value.icon,
          fill: "currentColor"
        }, null, 8, _hoisted_3)
      ])),
      _createElementVNode("span", _hoisted_4, _toDisplayString(config.value.label), 1)
    ], 2),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.count), 1)
  ], 10, _hoisted_1))
}
}

})